import {
  createDirectus,
  rest,
  authentication,
  readSettings,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get() {
  return await client.request(readSettings());
}

export default { get };
